<template>
  <div
    class="container-fluid promotion-page p-2 pt-3"
    style="scrollbar-width: none; -ms-overflow-style: none; height: 100vh; overflow-y: scroll; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
    <div style="height: 130vh;">
      <!-- <div class="my-3 d-flex flex-wrap px-0 mx-0">
            <button class="detail-button w-auto text-nowrap mx-1 my-1">ALL</button>
            <button class="detail-button w-auto text-nowrap my-1">NEW MEMBER</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
          </div> -->
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="card bg-transparent mt-2"
          style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; box-shadow: none;"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="#">
            <!-- https://t.me/hulk333vip -->
            <img
              :src="promotion.image"
              style="border-radius: 5px; width: 100%;"
              alt=""
            >
          </a>
          <div class="px-3 py-2 d-flex justify-content-between bg-transparent">
            <h3 class="text-dark my-auto">
              <!-- <picture class="mr-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
              {{ promotion.title }}
              <!-- <picture class="ml-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
            </h3>
            <button
              class="detail-button col-3"
              @click=" promotionIndex(proIndex)"
            >{{ $t('detail') }}</button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div
                class="col-11 card mx-auto my-auto py-4 px-3"
                style="background: #202124 !important;"
              >
                <h2
                  class="pb-3"
                  style="color: #d3d3d3"
                > {{ promotion.title }}</h2>
                <span
                  style="color: #B7AAAA"
                  v-html="promotion.description"
                ></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      // websiteInfo: [],
      isLoading: false,
      selectedPromotion: null,
      promotions: [
        // {
        //   title: 'မိတ်ဆက်ဘောနပ်စ်',
        //   description: `📌 သူငယ်ချင်းအားမိတ်ဆက်ပေးပြီး 𝐅𝐫𝐞𝐞  𝟓,𝟎𝟎𝟎 ရယူနိုင်ပါသည်။ <br><br>
        //                 📌 သင်မိတ်ဆက်ပေးသောသူငယ်ချင်း၏ပထမဆုံး သွင်းငွေမှာ အနည်းဆုံးကျပ် 𝟏𝟎,𝟎𝟎𝟎 ဖြစ်ရပါမည်။ <br><br>
        //                 📌 ရရှိသောဘောနပ်စ်သည် နိုင်ငွေ 𝟐 ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ <br><br>
        //                 📌 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
        //                 📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် 𝟏𝟎,𝟎𝟎𝟎 ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ 𝐚𝐮𝐭𝐨 နုတ်ယူသွားမည်ဖြစ်သည်။" <br><br>
        //                 ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>`,
        //   image: 'https://storage.googleapis.com/spacetech2/spin888/cards/BN50.webp',
        // },

        {
          title: 'မန်ဘာသစ်ဘောနပ်စ် 100%',
          description: `📌 SKK ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ်သာ ရယူနိုင်ပါသည်။<br />

📌 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟑,𝟎𝟎𝟎 အထက်ရှိရမည်။<br />

📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။<br />

📌 ဘောနပ်ယူပါက Free spin လုံးဝမဝယ်ရ။<br />

📌 Turnover , Amount  𝟏𝟎 ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ <br />
[( သွင်းငွေ+ဘောနပ်စ် ) x 10 ]<br />

❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ / ကာစီနိုဆော့ကစား၍မရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။<br />

📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် သွင်းငွေရဲ့  𝟏𝟎 ဆ ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ အော်တိုနုတ်ယူသွားမည်ဖြစ်သည်။<br />`,
          image: 'https://storage.googleapis.com/spacetech2/skk/new-memeber.avif',
        },
        {
          title: 'နေ့စဉ်ဘောနပ်စ် 𝟑𝟎% (တစ်နေ့ 1 ကြိမ်)',
          description: `📌 SKK ၏မန်ဘာဟောင်းတိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။ <br><br>
                        📌 အနည်းဆုံးသွင်းငွေ ကျပ် 𝟑,𝟎𝟎𝟎 အထက်ရှိရမည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့်ဘောနပ်စ်မှာ ကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။ <br><br>
                        📌 Turnover 4  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 𝟒  ] <br><br>
                        📌 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/skk/B2.avif',
        },
        // {
        //   title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3 ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် ရှမ်းကိုးမီး နှင့် ဘူကြီး ကစားနိုင်ပါသည်။`,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_4.jpg',
        // },
        // {
        //   title: 'SLOT သီးသန့်ပရိုမိုးရှင်း 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံးကျပ် 3,000 စသွင်းပါက ဒီပရိုမိုးရှင်းကိုရယူနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် Bonus မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည် <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် စလော့များကိုသာ ကစားနိုင်ပါသည်။
        //                 `,
        //   image: 'https://storage.googleapis.com/spacetech2/skk/B3.avif',
        // },
        {
          title: 'ရှူံးကြေးပြန်အမ်းငွေဘောနပ်စ် 5%',
          description: `📌 တစ်ရက်အတွင်း ရှူးထားသောငွေ၏ 5% ကိုပြန်ရယူနိုင်ပါသည် ။ <br><br>
                        📌 ရှူံးကြေးကို ည 3 နာရီမှသုံးနာရီနောက်ပိုင်းတွင် system မှ auto ပြန်အမ်းပေးပါသည် ။ <br><br>
                        📌 နိုင်ငွေ 1 ဆ ပြည့်မှသာငွေထုတ်ပေးပါမည် ။ <br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည် ။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/skk/new-loss-return.avif',
        },
        {
          title: 'သွင်းတိုင်းရ 𝟏𝟎%',
          description: `📌 အနည်းဆုံး 𝟓,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x𝟑]<br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/skk/B4.avif',
        },
      ]
    };
  },
  methods: {
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
    // async fetchWebsiteData() {
    //   try {
    //     const res = await axios.get('/website-infos');
    //     this.websiteInfo = res.data.data[0];
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    // await this.fetchWebsiteData();
    // this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.promotion-page {
  background: linear-gradient(180deg, #d1fae5 0%, #f0fdf4 22%, #ffffff 55%, #ecfdf5 100%);
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #0d5c2e;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #0a2410;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #14532d 0%, #0d5c2e 50%, #16a34a 100%);
  border-color: #14532d;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: linear-gradient(135deg, #0a2410 0%, #0d5c2e 100%);
  border-color: #0a2410;
}

.animate-charcter {
  text-transform: uppercase;
  background-image: linear-gradient(-225deg,
      #0d5c2e 0%,
      #f3e706 29%,
      #0d5c2e 67%,
      #f3e706 100%);
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  /* font-size: 190px; */
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
</style>